export enum ChapterContentType {
    VIDEO = 0,
    QUIZ = 1,
	PDF = 2,
	IMAGE = 3
};
